import { getStorageValue } from "./storage";

export function changeDir(lang) {
  document
    .querySelector(":root")
    .style.setProperty("direction", lang == "ar" ? "rtl" : "ltr");
}

export function changeElementDir(lang) {
  return lang == "ar" ? { direction: "rtl" } : { direction: "ltr" };
}

export function changeTheme(themes, theme) {
  const currTheme = themes[theme];
  for (const color in currTheme) {
    if (Object.hasOwnProperty.call(currTheme, color)) {
      const element = currTheme[color];
      updateColor(color, element);
    }
  }
}

function updateColor(property, color) {
  document.querySelector(":root").style.setProperty(`--${property}`, color);
}

export function getDir(lang) {
  return lang == "en" ? "ltr" : "rtl";
}
// let currentDir = document.querySelector(':root').style.getPropertyValue('--dir')
export const getCurrentLangFromRedux = () => {
  return getStorageValue("language");
};
export function getWidth() {
  return window.innerWidth >= 550;
}
